import { render, staticRenderFns } from "./aqualina-flats.vue?vue&type=template&id=45fcb8e8&"
import script from "./aqualina-flats.vue?vue&type=script&lang=js&"
export * from "./aqualina-flats.vue?vue&type=script&lang=js&"
import style0 from "./aqualina-flats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports